import styled from "styled-components"

const DropZoneWrapper = styled.div`
  display: block;
  margin-top: ${({theme}) => theme.spacing.four};
  .logo-drop-zone {
    height: 120px;
    border-width: 1px;
    border-color: #666;
    border-style: dashed;
  }
`

export default DropZoneWrapper
